import { render, staticRenderFns } from "./ChatComponent.vue?vue&type=template&id=4b864871&scoped=true&v-if=entitiesLoaded&"
import script from "./ChatComponent.vue?vue&type=script&lang=js&"
export * from "./ChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChatComponent.vue?vue&type=style&index=0&id=4b864871&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b864871",
  null
  
)

export default component.exports